import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

interface DoubleStringBrand {
    readonly DoubleString: unique symbol;
}

export const DoubleString = brand(
    NonEmptyString,
    // eslint-disable-next-line security/detect-unsafe-regex
    (n): n is Branded<NonEmptyString, DoubleStringBrand> => /^-?\d+(\.\d+)?$/.test(n),
    'DoubleString'
);

export type DoubleString = TypeOf<typeof DoubleString>;
